import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faUserShield,faCreditCard,faMoneyBillTrendUp,
} from "@fortawesome/free-solid-svg-icons";

const features = [
	{
		icon: faUserShield,
		title: "Get more from life with Insurance",
		desc: "Banking crises have developed many times throughout history when one or more risks have emerged for a banking sector as a whole.",
	},
	{
		icon: faMoneyBillTrendUp,
		title: "Make Your Dream comes true with our affordable loan",
		desc: "Get the support you need with our hassle-free loans – quick approval, low rates, and endless possibilities!",
	},
	{
		icon: faCreditCard,
		title: "Swipe smart, live rich your Credit Card, your World of rewards",
		desc: "Unlock a world of benefits with every swipe your credit card, your gateway to rewards and convenience.",
	},
];

const FeatureItem = ({ feature }) => {
	return (
		<div className="flex bg-white shadow-xl relative p-3 md:p-6 xl:p-12 mb-4 lg:mb-6">
			<div className="text-blue-600 rounded-full text-[42px] mb-6 mr-6 xl:mr-12">
				<FontAwesomeIcon icon={feature.icon} />
			</div>
			<div>
				<h4 className="text-xl font-bold mb-4">{feature.title}</h4>
				<p>{feature.desc}</p>
			</div>
		</div>
	);
};

FeatureItem.propTypes = {
	feature: PropTypes.object.isRequired,
};

const Feature = () => {
	return (
		<section className="py-14 md:py-24 bg-white overflow-hidden">
			<div className="max-w-7xl px-4 mx-auto">
				<div className="flex max-w-2xl justify-start text-start mb-5">
					<div>
						<h2 className="text-3xl font-bold leading-tight md:text-[40px] mb-6 uppercase">
            We Care the Finance
						</h2>
						<p className="text-lg mb-6">
            Your Financial Well-Being, Our Top Priority – We Care About Your Future
						</p>
					</div>
				</div>
				<div className="grid grid-cols-2 gap-6 md:pt-12 max-w-7xl mx-auto">
					<div className="col-span-2 lg:col-span-1">
						<div className="relative h-full z-10">
							<div
								className="bg-center bg-no-repeat bg-cover rounded-2xl min-h-[350px] w-full float-right shadow-xl h-full"
								style={{
									backgroundImage:
										"url(https://images.pexels.com/photos/6963848/pexels-photo-6963848.jpeg?auto=compress&cs=tinysrgb&w=600)",
								}}
							/>
						</div>
					</div>
					<div className="col-span-2 lg:col-span-1">
						<div className="lg:ml-6 xl:ml-12">
							{features.map((feature, i) => (
								<FeatureItem feature={feature} key={i} />
							))}
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Feature;